<template>
  <div class="support-banner">
    <div class="support-banner__text">
      <h2 class="support-banner__title">{{ title }}</h2>
      <p class="support-banner__subtitle">{{ subtitle }}</p>
    </div>
    <img class="support-banner__mascot" :src="mascotUrl" alt="" aria-hidden="true" loading="lazy" />
  </div>
</template>

<script setup lang="ts">
import { getWebpUrl } from '@/utils/webpAssets'

defineProps<{
  /** 主标题，例如 24/7 Live Support */
  title: string
  /** 副标题描述文案 */
  subtitle: string
}>()

const mascotUrl = getWebpUrl('imgs/customer/cs_mascot.webp')
</script>

<style scoped lang="scss">
.support-banner {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 128px;
  flex-shrink: 0;
  padding: 0 20px;
  border-radius: 16px;
  overflow: hidden;
  background-image: linear-gradient(108.83deg, rgba(63, 54, 43, 0.6) 1%, rgba(52, 29, 0, 0.6) 100%);
  box-shadow: inset 0 4px 20px 0 #3d3124;

  &__text {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 220px;
  }

  &__title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: var(--title-color, #e8ba6e);
  }

  &__subtitle {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    color: #a09281;
  }

  &__mascot {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 160px;
    height: auto;
    object-fit: contain;
    opacity: 0.9;
    pointer-events: none;
  }
}
</style>
